import { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { accountAtom, accountDataAtom, execGetAccount } from "../atoms";
import { useConfig } from "../modules/config";

const AccounteUpdater = () => {
  const account = useRecoilValue(accountAtom);
  const { apiUrl, accountPollTimeout } = useConfig();

  const setAccountData = useSetRecoilState(accountDataAtom);

  useEffect(() => {
    const i = setInterval(() => {
      if (!account) {
        return;
      }

      void (async () => {
        const data = await execGetAccount(account, { baseUrl: apiUrl });

        setAccountData(data);
      })();
    }, accountPollTimeout);

    return () => {
      clearInterval(i);
    };
  }, [account, apiUrl, accountPollTimeout, setAccountData]);
  return null;
};

export default AccounteUpdater;
